import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setRolePage } from '../redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useRoleSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getRoleSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website.role_page.role_section}`);
      console.log("🚀 ~ getRoleSectionJson ~ data:", response);
      console.log("🚀 ~ getRoleSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setRolePage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Role section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getRoleSectionJson();
  }, [getRoleSectionJson]);

  return {
    data,
    loading,
    error,
    getRoleSectionJson,
    fetchOnMount,
    refetch: getRoleSectionJson
  };
};

export default useRoleSection;
